export const CLEANUP_OUR_APPS_PAGE_STATE = 'cleanup-our-apps-page-state';
const cleanupOurAppsPageState = () => ({ type: CLEANUP_OUR_APPS_PAGE_STATE });
export default cleanupOurAppsPageState;
